import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../helpers/axiosInstance";
import { toast } from "react-toastify";

const initialState = {
  allAvailableCountryCodeList: [],
  allAvailableCountryCodeCategories: [],
  countryCodeBlockData: [],
  pagination: null,
  loading: false,
  error: null,
};

export const getAllAvailableCountryCodeList = createAsyncThunk(
  "countryCodeBlock/getAllAvailableCountryCodeList",
  async ({ user, search }) => {
    try {
      const { url, endpoint } = user?.routesConfig;
      const base = url?.acsbackofficemanagement;
      const endpointpath = endpoint?.acsbackofficemanagement?.getCountries;

      const apiURL = base + endpointpath;
      const response = await axiosInstance.post(apiURL, search);
      return { ...response?.data, status: response.status };
    } catch (error) {
      toast.error(error?.data?.message || "Failed to fetch available countries");
      throw error.response;
    }
  }
);

export const getAllCountryBlockList = createAsyncThunk(
  "countryCodeBlock/getAllCountryBlockList",
  async ({ user, pagination, orderBy, search }) => {
    try {
      const { url, endpoint } = user?.routesConfig;
      const { pageSize, currentPage } = pagination;

      const base = url?.acsbackofficemanagement;
      const endpointpath = endpoint?.acsbackofficemanagement?.getBlockedCountries;

      const apiURL = `${base}${endpointpath}/${pageSize}/${currentPage}`;
      const response = await axiosInstance.post(apiURL, search);

      // if (response.status === 200) {
      //   if(response.data?.totalItem === 0) {
      //     toast.error(response.data?.responseDescription || "No records found");
      //     return response?.data;
      //   }
      // }

      return response?.data;
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to fetch blocked countries");
      throw error.response;
    }
  }
);

export const postAddUpdateCountryCodeBlock = createAsyncThunk(
    "country code block management/add/update country code block",
    async ({ user, body }) => {
        try {
            const { url, endpoint } = user?.routesConfig;

            const base = url?.acsbackofficemanagement;
            const endpointpath = endpoint?.acsbackofficemanagement?.saveMakerBlockedCountry;

            const apiURL = base + endpointpath;

            const response = await axiosInstance.post(apiURL, body);

            if (response?.data?.responseCode === '400') {
                toast.error(response?.data?.responseDescription);
                return { status: response?.data?.responseCode };
            }

            toast.success('Request has been initiated and sent to checker');
            return { ...response?.data, status: response.status };
        } catch (error) {
            toast.error(error.response.data.message);
            throw error.response;
        }
    }
);

const countryCodeBlockSlice = createSlice({
  name: "countryCodeBlock",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // GET ALL AVAILABLE COUNTRY CODES LIST
      .addCase(getAllAvailableCountryCodeList.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.allAvailableCountryCodeList = [];
        state.allAvailableCountryCodeCategories = [];
      })
      .addCase(getAllAvailableCountryCodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.allAvailableCountryCodeCategories = action?.payload?.data
          ? action?.payload?.data.map(({ name, isoAlpha2 }) => ({
              label: name,
              value: isoAlpha2,
            }))
          : [];
        state.allAvailableCountryCodeList = action?.payload?.data || [];
      })
      .addCase(getAllAvailableCountryCodeList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // GET ALL COUNTRY CODE BLOCK LIST
      .addCase(getAllCountryBlockList.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.countryCodeBlockData = [];
      })
      .addCase(getAllCountryBlockList.fulfilled, (state, action) => {
        const { resp, currentPage, pageSize, totalItem, totalPages } = action?.payload;
        state.loading = false;
        state.countryCodeBlockData = resp || [];
        state.pagination = { currentPage, pageSize, totalItem, totalPages };
      })
      .addCase(getAllCountryBlockList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
    // REMOVE COUNTRY CODE BLOCK
      .addCase(postAddUpdateCountryCodeBlock.pending, (state) => {
        state.error = null;
      })
     .addCase(postAddUpdateCountryCodeBlock.fulfilled, (state, action) => {
        state.loading = false;
      })
     .addCase(postAddUpdateCountryCodeBlock.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
     });
  },
});

export default countryCodeBlockSlice.reducer;
